var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTopOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2B4995",
    d: "M5.867 10.133h4.266V5.867H5.867z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2B4995",
    d: "M16 16V1.25L13.172 4.08v9.093H4.078L1.25 16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3C65BA",
    d: "M0 0v14.75l2.828-2.829V2.828h9.094L14.75 0z"
  }))));
}
export default __webpack_public_path__ + "static/_/_/ugg/shared/assets/svg/roles/alt-1/top-off.svg";
export { SvgTopOff as ReactComponent };